import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  birthdayTitle: {
    defaultMessage: 'DATE OF BIRTH',
    id: 'cQB2EL',
    description: 'DATE OF BIRTH field title',
  },
  birthdayMinAgeError: {
    defaultMessage: 'You need to be at least 18 years of age',
    id: 'bdjV3H',
    description: 'Field validation message',
  },
  genderTitle: {
    defaultMessage: 'Gender',
    id: 'onboarding_gender_title',
    description: 'Gender field title',
  },
  gbLicensingAuthorityTitle: {
    defaultMessage: 'Licensing authority',
    id: '/Q8aMx',
    description: 'field title',
  },
  gbLicensingAuthorityDesc: {
    defaultMessage:
      'If multiple authorities license you, choose only one. Learn more about license types <a>here</a>.',
    id: 'EUTZOe',
    description: 'field description',
  },
  gbDriverLicenseTitle: {
    defaultMessage: 'Private Hire Driver License Number',
    id: 'pFGlVW',
    description: 'PHD License Number field title',
  },
  gbDriverLicenseDesc: {
    defaultMessage: 'Full PHD license number from your licensing authority.',
    id: 'NB/idy',
    description: 'input tip',
  },
  gbInsuranceTitle: {
    defaultMessage: 'NATIONAL INSURANCE NUMBER',
    id: 'N/hPyL',
    description: 'NATIONAL INSURANCE NUMBER field title',
  },
  gbInsurancePatternError: {
    defaultMessage: 'Wrong national insurance number, ex. AB123456C.',
    id: '5rqrKE',
    description: 'NATIONAL INSURANCE NUMBER field error message',
  },
  frVtcTitle: {
    defaultMessage: 'VTC (PRIVATE HIRE) REGISTRATION NUMBER',
    id: 'RdRdnV',
    description: 'FR VTC field title',
  },
  frVtcDesc: {
    defaultMessage: 'Example: EVTC12345678.',
    id: 'A7nLWH',
    description: 'FR VTC field input tip',
  },
  usDriverLicenseTitle: {
    defaultMessage: 'TLC Driver License Number',
    id: 'us_tlc_driver_license_number_title',
    description: 'US TLC Driver License number field title',
  },
  ruInnTitle: {
    defaultMessage: 'Your INN',
    id: 'JGFKJo',
    description: 'Your INN field title',
  },
  ruInnDesc: {
    defaultMessage: 'INN for individuals consists of 12 digits. <link>Where to find?</link> ',
    id: 'C9rzp+',
    description: 'Your INN field description',
  },
  addressTitle: {
    defaultMessage: 'HOME ADDRESS',
    id: 'rx3Bk0',
    description: 'HOME ADDRESS section title',
  },
  addressLine1Title: {
    defaultMessage: 'Address Line 1',
    id: 'address_line1_title',
    description: 'Address line 1 placeholder',
  },
  addressLine2Title: {
    defaultMessage: 'Address Line 2 (Optional)',
    id: 'address_line2_title',
    description: 'Address line 2 optional placeholder',
  },
  addressCityTitle: {
    defaultMessage: 'City',
    id: 'address_city_title',
    description: 'City placeholder',
  },
  addressStateTitle: {
    defaultMessage: 'State',
    id: 'address_state_title',
    description: 'State placeholder (US only)',
  },
  addressPostcodeTitle: {
    defaultMessage: 'Postcode',
    id: 'address_postcode_title',
    description: 'Postcode placeholder',
  },
  addressZipCodeTitle: {
    defaultMessage: 'Zip Code',
    id: 'address_zip_code_title',
    description: 'Zip code placeholder (US only)',
  },
  docsTitle: {
    defaultMessage: 'ADD DOCUMENTS',
    id: 'pytlFK',
    description: 'Docs list title',
  },
});
